import { AudienceSyncSchedule, AudienceSyncScheduleType, AudienceSyncTimeBasedSchedule } from '@/models/audiences';
import React, { FC, Fragment } from 'react';
import { AudienceSyncRepeatConfig } from './AudienceSyncRepeatConfig';
import { AudienceSyncTypeConfig } from './AudienceSyncTypeConfig';

type AudienceSyncConfigProps = {
  isFetchingSummary: boolean;
  realTimeAudienceLeft: number;
  scheduleType: AudienceSyncScheduleType;
  scheduleConfiguration: AudienceSyncSchedule;
  handleChange: (e: React.ChangeEvent<any>) => void;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};

export const AudienceSyncConfig: FC<AudienceSyncConfigProps> = ({
  isFetchingSummary,
  realTimeAudienceLeft,
  scheduleType,
  scheduleConfiguration,
  handleChange,
  setFieldValue,
}) => {
  return (
    <div className='mt-6 h-auto'>
      <AudienceSyncTypeConfig
        isFetchingSummary={isFetchingSummary}
        realTimeAudienceLeft={realTimeAudienceLeft}
        scheduleType={scheduleType}
        handleChange={handleChange}
      />
      {scheduleType === 'SCHEDULED' && (
        <Fragment>
          <hr />
          <AudienceSyncRepeatConfig scheduleConfiguration={scheduleConfiguration as AudienceSyncTimeBasedSchedule} setFieldValue={setFieldValue} />
        </Fragment>
      )}
    </div>
  );
};
